import { Block } from "@mui/icons-material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { AccessDeniedMessageWrapper } from "./access-denied-message.styled";

export const AccessDeniedMessage: FC = () => {
  const { t } = useTranslation();

  return (
    <AccessDeniedMessageWrapper>
      <Block className="access-denied-icon" />
      <h2 className="access-denied-title">
        {t("ui.YOU_DONT_HAVE_PERMISSIONS_TO_ACCESS_THIS_PAGE")}
      </h2>
    </AccessDeniedMessageWrapper>
  );
};
